export interface QuestionModel {
    userAnswer: String[];
    sourceQuiz: unknown;
    uuid: string;
    timeSpent: number;
    multipleSelect: boolean;
}

export class Question implements QuestionModel {
    userAnswer = [] as String[];

    sourceQuiz = {} as string | JSON;

    uuid = '';

    timeSpent = 0;

    multipleSelect = false;

    constructor(userAnswer: [], sourceQuiz: string | JSON, uuid: string, timeSpent: number, multipleSelect: boolean) {
      if (userAnswer === null || userAnswer === undefined) {
        this.userAnswer = [];
      } else {
        this.userAnswer = userAnswer;
      }
      this.sourceQuiz = sourceQuiz;
      this.uuid = uuid;
      this.timeSpent = timeSpent;
      this.multipleSelect = multipleSelect;
    }
}
